import Vue from 'vue'
import Vuex from 'vuex'
import api from '../service'
import actions from './actions'
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios'

Vue.use(Vuex)

const state = {
    uid: '',
    uuid: '',
    userName: '',
    errorState: '',
    isAuth: false,
    token: '',
    showLayerContent: '',
    nextRoute: '',
	errorCode: ''
}

const getters = {
    getUid: state => state.uid,
    getUuid: state => state.uuid,
    getUserName: state => state.userName,
    getErrorState: state => state.errorState,
    getIsAuth: state => state.isAuth,
    getToken: state => state.token,
    getShowLayerContent: state => state.showLayerContent,
    getNextRoute: state => state.nextRoute,
	getErrorCode: state => state.errorCode
}

const mutations = {
    ['UID'](state, uid) {
        state.uid = uid
    },
    ['UUID'](state, uuid) {
        state.uuid = uuid
    },
    ['USERNAME'](state, userName) {
        state.userName = userName
    },
    ['ERROR_STATE'](state, errorState) {
        state.errorState = errorState
    },
    ['IS_AUTH'](state, isAuth) {
        state.isAuth = isAuth
    },
    ['TOKEN'](state, jwt) {
        state.token = jwt
    },
    ['NEXT_ROUTE'](state, nextRoute){
        state.nextRoute = nextRoute
    },
	['ERROR_CODE'](state, errorCode){
        state.errorCode = errorCode
    },
    increment: state => state.count++,
    decrement: state => state.count--
}

const enhanceAccessToken = () => {
    const vuex = JSON.parse(localStorage.getItem('vuex'))
    if (!vuex || !vuex.token) return
    axios.defaults.headers.common['Jwt-Auth'] = `${vuex.token}`;
}
enhanceAccessToken()

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    plugins: [createPersistedState()],
})



// WEBPACK FOOTER //
// ./src/vuex/store.js